import { useEffect, useState } from 'react'
import { defaultProjects, defaultSiteContent } from '../data/defaultContent'
import { fetchPublicProjects, fetchPublicSiteContent } from '../lib/publicApi'
import { heroSlidesWithLegacy } from '../lib/heroSlides'
import type { Project, SiteContent } from '../types'

export function useSiteData() {
  const [content, setContent] = useState<SiteContent>(defaultSiteContent)
  const [projects, setProjects] = useState<Project[]>(defaultProjects)
  const [contentReady, setContentReady] = useState(false)
  const [projectsReady, setProjectsReady] = useState(false)

  useEffect(() => {
    let active = true
    const contentController = new AbortController()
    const projectsController = new AbortController()
    const contentTimeout = window.setTimeout(() => contentController.abort(), 4500)
    const projectsTimeout = window.setTimeout(() => projectsController.abort(), 6000)

    fetchPublicSiteContent(contentController.signal)
      .then((result) => {
        if (!active) return
        if (result) {
          const next = { ...defaultSiteContent, ...result }
          setContent({ ...next, heroSlides: heroSlidesWithLegacy(next) })
        }
      })
      .catch(() => undefined)
      .finally(() => {
        window.clearTimeout(contentTimeout)
        if (active) setContentReady(true)
      })

    fetchPublicProjects(projectsController.signal)
      .then((result) => {
        if (active && result) setProjects(result)
      })
      .catch(() => undefined)
      .finally(() => {
        window.clearTimeout(projectsTimeout)
        if (active) setProjectsReady(true)
      })

    return () => {
      active = false
      window.clearTimeout(contentTimeout)
      window.clearTimeout(projectsTimeout)
      contentController.abort()
      projectsController.abort()
    }
  }, [])

  return { content, projects, loading: !contentReady || !projectsReady, contentReady }
}
